import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReportProblem = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 21.5L12 2.5L23 21.5H1ZM19.5297 19.4983L11.9997 6.48828L4.46973 19.4983H19.5297ZM11 16.5V18.5H13V16.5H11ZM11 10.5H13V14.5H11V10.5Z",
		fill: "#E99921"
	})
});
export default SvgReportProblem;
